import { t } from "i18next";
export const AIRPORT_AREA_MAPPER = {
    sbø: t("pax.widgets.queueTimes.east"),
    sbv: t("pax.widgets.queueTimes.west"),
    eu: "EU",
    noneu: "Non-EU",
    t1: "Terminal 1",
    t3: "Terminal 3"
};
export const mapQueueTimeAreatoName = (area) => {
    var _a;
    return (_a = AIRPORT_AREA_MAPPER[area]) !== null && _a !== void 0 ? _a : area;
};
